<script>
    import Header from '../global/header.svelte'
    import Loader from '../widgets/loader.svelte'
    import { onMount } from 'svelte';

    let news = [];
    let selectedArticle = "";
    let loading = true;

	onMount(async () => {
		const res = await fetch(`https://api.southernco-op.co.uk/news/get`);
        news = await res.json();
        if( news.ok ) {
            loading = false;
        } else {
         loading = false;
        }
	});

    function loadArticle( oArticle ) {
        selectedArticle = oArticle;

        console.log( selectedArticle );



        var content = selectedArticle.atom_content;

         var temp = document.createElement("div");
         temp.innerHTML = content;

        var anchors = temp.getElementsByTagName('a');
        
        for (var i=0; i<anchors.length; i++){
            anchors[i].setAttribute('target', '_blank');
            anchors[i].removeAttribute("href");
        }

      
        selectedArticle.atom_content = temp.innerHTML;

          
            dataLayer.push({
                'event':'CustomEvent',
                'category':'News',
                'action':'News Story Viewed',
                'label': selectedArticle.title
            });
        


    }

    function closeArticle() {
        selectedArticle = "";
    }

    function timeConverter(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var time = date + ' ' + month + ' ' + year;
        return time;
    }

</script>


<svelte:head>
    <title>News Page</title>
</svelte:head>

<style>
img {
    width: 100%;
    max-width: auto;
}
    span {
        color: var(--brand-color);
        font-size: 1.5rem;
        font-weight: 500;
    }
    h2 {
        font-size: 22px;
        font-size: 2.2rem;
        line-height: 24px;
        line-height: 2.4rem;
         font-weight: 500;
    }
    article {
        border-bottom: 1px solid rgba(255,255,255,.3);
        padding-bottom: 1em;
        margin-bottom: 1em;
    }
    button {
        background: none;
        border: none;
        padding: 0 15px 0 0;
        color: #fff;
        position: relative;
    }
    img {
       
    }
    button:after {
        content:'';
        background-image: url('../svg/angle-right.svg');
        background-size: 6px 11px;
        width: 6px;
        height: 11px;
        position: absolute;
        top: 50%;
        margin-top: -6px;
        right: 0;
    }

    :global(.news_article img)  {
         display: block;
         margin: 1em auto;
     }

     @media screen and ( min-width: 600px ) {
        :global(.news_article img)  {
                float: left;
                margin: 1em 1em 1em 0;
         }
     }

   
</style>


{#if selectedArticle}
    <header class="header">
        <div>
            <a href="#close" on:click={closeArticle}>
                 <svg xmlns="http://www.w3.org/2000/svg" width="12.387" height="21.667" viewBox="0 0 12.387 21.667">
                    <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.985,17.024l8.2-8.192A1.548,1.548,0,0,0,20.99,6.646L11.7,15.928a1.545,1.545,0,0,0-.045,2.135l9.327,9.346a1.548,1.548,0,1,0,2.193-2.187Z" transform="translate(-11.251 -6.194)" fill="#00627d"/>
                </svg>
            </a> 
            <h1>News</h1>
        </div>
         <img src="svg/header-waves.svg" class="waves" alt="Waves" aria-hidden="true" />
    </header>
    <section class="news_article">
        <span>{ timeConverter(selectedArticle.date_timestamp) }</span>
        <h2>{@html selectedArticle.title}</h2>
        <div>
            {@html selectedArticle.atom_content}
        </div>
    </section>
{:else}
    <Header title="News" url="/" /> 
    <section>
        <div>
             {#if !loading}
                {#if news.length }
                    {#each news as article}
                        <article on:click={loadArticle(article)}>
                            <span>{ timeConverter(article.date_timestamp) }</span>
                            <h2>{@html article.title}</h2>
                            <button >Read Story</button> 
                        </article>
                    {/each}
                {:else} 
                    <p>No news articles</p>
                {/if}
                    
             {:else}
                 <Loader msg="Loading news articles" />
            {/if}
        </div>
    </section>
{/if}



